/** Presentation-only Uzbek phone helpers for the admin service. */
export function formatUzPhone(raw: string | null | undefined): string {
  if (!raw) return "";
  if (!/^[+()\d\s-]+$/.test(raw)) return raw;
  const digits = raw.replace(/\D/g, "");
  if (!/^998\d{9}$/.test(digits)) return raw;
  return `+998 ${digits.slice(3, 5)} ${digits.slice(5, 8)} ${digits.slice(8, 10)} ${digits.slice(10, 12)}`;
}

export function isBlankPhoneInput(value: string): boolean {
  const digits = value.replace(/\D/g, "");
  return digits === "" || digits === "998";
}

/** Keep phone search compatible with canonical, unspaced backend values. */
export function phoneSearchQuery(value: string): string {
  const trimmed = value.trim();
  return /^[+\d\s()-]+$/.test(trimmed) ? trimmed.replace(/\D/g, "") : trimmed;
}
